module.exports = __webpack_public_path__ + "static/media/logo.7cb6acec.png";